import * as React from "react";
import ILabTestMaster from "../../models/ILabTestMaster";
import AllLabTestsContainer from "../AllLabTestsContainer";
import DiagnosticLabTestEditViewCont from "../../containers/EditView/DiagnosticLabTestEditViewCont";
import { AppMessages } from "../../utils/AppConstants";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import { IAddMetric } from "@curefit/metrics-common";
import { EditViewDisplayMode } from "../common/EditViewCard";
import * as _ from "lodash";
import * as moment from "moment";;
import AppUtils from "../../utils/AppUtils";
import CollapsibleCardView from "../CollapsibleCardView";
import LabTestRow from "../LabTestRow";
import LabTestEditViewCont from "../../containers/EditView/DiagnosticLabTestEditViewCont";
import { ILabtestPrescription, IDiagnosticLabTestItem } from "@curefit/care-common";
import ConfirmModalContainer from "../../containers/ConfirmModalContainer";
import CTA, { CTATheme } from "../common/CallToAction";

/**
 * Created by abhinav on 05/02/18.
 */

export interface PatientDiagnosticLabTestsTabProps {
    patientLabTests: ILabTestMaster[];
    curefitUserId: number;
    patientId: number;
    nextTab: () => void;
    fetchStaticLabTestsData?: (input: string) => Promise<any>,
    savePatientDiagnosticLabTests: (req: ILabtestPrescription[]) => Promise<any>;
    fetchStaticDiagnosticLabTests: (input: string) => Promise<any>;
    saveEditedPatientProfile?: (updatedPatientPlan: IPatientLifestylePlanWrapper) => void;
    savePatientLabTestsSuccess: (dataObj: object) => Promise<any>,
    savePatientLabTests: (patientLabTests: any) => void,
    updateDiagnosticLabTests: (diagnosticLabTests: any) => void,
    saveEditedPatientLabTests: (diagnosticLabTests: any) => void,
    diagnosticLabTests: any,
    deletePatientDiagnosticLabTests: (deletedLabTestIds: number[]) => Promise<any>;
    manualLabTests: IDiagnosticLabTestItem[];
    saveManualLabTests: (diagnosticLabTests: IDiagnosticLabTestItem[]) => void;
}

export interface PatientDiagnosticLabTestsTabState {
    error: string,
    errorDetails?: string,
    errorPresent?: boolean,
    showLabTestForm: boolean
}


class PatientDiagnsoticLabTestsTab extends React.Component<PatientDiagnosticLabTestsTabProps, PatientDiagnosticLabTestsTabState> {
    private diagnosticlabTestsRef: LabTestEditViewCont;

    constructor(props: PatientDiagnosticLabTestsTabProps) {
        super(props);
        this.state = {
            error: null,
            errorPresent: false,
            showLabTestForm: !_.isEmpty(props.manualLabTests)
        }
    }

    componentWillReceiveProps(nextProps: PatientDiagnosticLabTestsTabProps) {
        if (!_.isEmpty(nextProps.manualLabTests) && !this.state.showLabTestForm) {
            this.setState({ showLabTestForm: true })
        }
    }

    componentWillUnmount() {
        this.saveEditedPatientTests();
    }

    getPlanSaveObject(): { diagnosislabTests: IDiagnosticLabTestItem[] } {
        let diagnosticsLabTests = this.diagnosticlabTestsRef.getSaveObject();

        let updatedLabTestObject = {
            diagnosislabTests: diagnosticsLabTests,
        };
        return updatedLabTestObject;
    }

    // getEditedOrAddedLabTests(): ILabtestPrescription[] {
    //     let editedOrAddedLabTests: ILabtestPrescription[] = []
    //     let updatedLabTests: ILabtestPrescription[] = this.getPlanSaveObject().diagnosislabTests;
    //     let mapping: { [key: string]: ILabtestPrescription } = {};
    //     this.props.diagnosticLabTests.forEach((labTest: ILabtestPrescription) => {
    //         mapping[labTest.id] = labTest;
    //     })
    //     updatedLabTests.forEach((labTest: ILabtestPrescription) => {
    //         if (!(mapping[labTest.id])) {
    //             editedOrAddedLabTests.push(labTest);
    //         } else {
    //             if ((mapping[labTest.id].metric && labTest.name !== mapping[labTest.id].metric.name)
    //             || (!mapping[labTest.id].metric && labTest.name !== mapping[labTest.id].name)
    //             || Number(labTest.value) !== Number(mapping[labTest.id].value)
    //             || new Date(labTest.metricDate).getTime() !== Number(mapping[labTest.id].metricDate)
    //             || (!_.isNull(mapping[labTest.id].sourceMetadata) && labTest.sourceMetadata.source !== mapping[labTest.id].sourceMetadata.source)
    //             || (_.isNull(mapping[labTest.id].sourceMetadata) && !_.isNull(labTest.sourceMetadata))) {
    //                 editedOrAddedLabTests.push(labTest);
    //             }
    //         }
    //     })
    //     return editedOrAddedLabTests;
    // }

    validatePlan() {
        let diagnosticLabTestStatus = this.diagnosticlabTestsRef.isFormDirty();
        if (
            !diagnosticLabTestStatus
        ) {
            return true;
        } else {
            if (diagnosticLabTestStatus) this.invalidItemError("Lab Tests")
            return false;
        }
    }

    invalidItemError = (section: string, errorText?: string) => {
        let errorDisplayText = !_.isEmpty(errorText) ? errorText : "";
        this.setState({
            errorPresent: true,
            error: AppMessages.PLAN_VALIDATION_ERROR,
            errorDetails: `Error in ${section}. Please Review the form and proceed. ${errorDisplayText}`
        })
    }

    formatDiagnosticLabTestsAccordingToMetricDate() {
        let formattedDiagnosticLabTest: any = {};
        if (this.props.diagnosticLabTests && this.props.diagnosticLabTests.length > 0) {
            this.props.diagnosticLabTests.map((test: any) => {
                let metricDate = moment(test.metricDate).format("DD MMMM, YYYY")
                if (!formattedDiagnosticLabTest[metricDate]) {
                    formattedDiagnosticLabTest[metricDate] = [];
                }
                formattedDiagnosticLabTest[metricDate].push(test);
            });
        }
        return formattedDiagnosticLabTest;
    }

    saveEditedPatientTests = () => {
        if (this.diagnosticlabTestsRef) {
            this.props.saveManualLabTests(this.diagnosticlabTestsRef.getSaveObject());
        }
    };

    resetErrors = () => {
        this.setState({
            error: null,
            errorPresent: false,
            errorDetails: ""
        })
    }

    handleAddButtonClick = (event: any) => {
        event.preventDefault();
        this.setState({ showLabTestForm: true });
    };

    hideLabTestForm = () => {
        this.setState({ showLabTestForm: false });
        this.props.saveManualLabTests([])
    };

    getRightSideUI(newFormat: any, date: string): React.ReactNode {
        return <div className="labTest-container">
            <div className={"labTest-rows patient-diag"}>
                <div key={`labTest-child-${date}`}>
                    <LabTestRow labTestRow={newFormat[date]} />
                </div>
            </div>
        </div>
    }

    render() {
        let labTests = this.props.patientLabTests;
        let formattedDiagnosticTests = this.props.diagnosticLabTests && this.formatDiagnosticLabTestsAccordingToMetricDate();
        let newFormat: { [key: string]: any } = {};
        Object.keys(formattedDiagnosticTests).map((date: any) => {
            let testsForOneDay = formattedDiagnosticTests[date];
            let formattedTestsForDay: any = {
                childCheckUpReportInfo: []
            }
            testsForOneDay.map((test: any) => {
                formattedTestsForDay.childCheckUpReportInfo.push({
                    reportDetails: {
                        testResultValue: test.value,
                        testName: test.metric ? test.metric.name : test.name,
                        testMeasuringUnit: test.metric ? test.metric.unit : !_.isEmpty(test.testCondition) ? test.testCondition.internalValue : ""
                    }
                })
            })
            newFormat[date] = formattedTestsForDay;
        });

        return (
            <div className="labtests-tab-container">
                {
                    !this.state.showLabTestForm &&
                    <CTA innerText={"Add Lab Tests"} theme={CTATheme.PRIMARY} onClick={this.handleAddButtonClick} customStyle={{ width: 130, marginBottom: 10, position: "absolute", top: "calc(100vh - 119px)", left: "calc(100vw - 150px)" }} />
                }
                {
                    this.state.showLabTestForm &&
                    <DiagnosticLabTestEditViewCont ref={(labTestsDOM) => { this.diagnosticlabTestsRef = labTestsDOM }} patientLabTest={this.props.manualLabTests} patientId={this.props.patientId}
                        curefitUserId={this.props.curefitUserId}
                        savePatientDiagnosticLabTests={this.props.savePatientDiagnosticLabTests}
                        savePatientLabTests={this.props.savePatientLabTests}
                        fetchStaticLabTests={this.props.fetchStaticDiagnosticLabTests}
                        displayMode={EditViewDisplayMode.EDIT}
                        hideLabTestForm={this.hideLabTestForm}
                        saveEditedPatientTests={this.props.saveManualLabTests}
                        handleInvalidItemError={this.invalidItemError}
                    />
                }

                <AllLabTestsContainer labTests={labTests} userId={this.props.curefitUserId.toString()} diagnosticLabTests={this.props.diagnosticLabTests} newFormat={newFormat} getRightSideUI={this.getRightSideUI} />

                {/* {
                    Object.keys(newFormat).map((date, index) => {
                        return (<div className="labTest-container">
                            <CollapsibleCardView titleComponent={date} key={index}
                                showCollapseButton={true}>
                                <div className={"labTest-rows patient-diag"}>
                                    <div key={`labTest-child-${date}`}>
                                        <LabTestRow labTestRow={newFormat[date]} />
                                    </div>
                                </div>
                            </CollapsibleCardView>
                        </div>)
                    })
                } */}
                {
                    this.state.errorPresent &&
                    <ConfirmModalContainer
                        errorText={this.state.error}
                        errorDetails={this.state.errorDetails}
                        okCallBack={this.resetErrors}
                        cancelCallBack={this.resetErrors}
                    />
                }
            </div>
        );
    }
}

export default PatientDiagnsoticLabTestsTab